export const MultiTriageContent = {
  dropDownText: 'Please Select One',
  pageTitle: 'Inheriting a Vanguard account',
  pageDescription:
    'Inheritances can be complicated, so we start by asking a few questions that’ll help set up the rest of the process.',
  continueButton: 'Continue',
  clientRadioQuestion: 'Are you a Vanguard client?',
  radioButtonHintError: 'Make a selection to continue',
  trusteeOrEstateRadioQuestion: 'Are you inheriting an account into a trust or estate?',
  inheritingMultipleAccountsRadioQuestion: 'Are you inheriting more than one account?',
  trustOrEstateBannerText:
    'Because trust and estate transfers are a little more complex, we have to process each of those separately. Click ‘continue’ to begin inheriting an account into a trust or estate. Once you’re done, return to this page and complete your request for all remaining account types.',
  rightRailAccordion: [
    {
      title: `What if I need to make changes to an existing trust after a loss?`,
      content: `To update trust information due to the loss of a grantor or trustee, use our <a class="c11n-link c11n-link--reinforced c11n-link--bold" href="https://personal1.vanguard.com/cwp-change-of-ownership-angular/inheritance/trust-triage"><span class="c11n-link__content">new digital trust experience.</span></a>`,
    },
    {
      title: `What if there are multiple beneficiaries?`,
      content: `Each beneficiary will have to complete this process to inherit the assets.`,
    },
  ],
  rightBannerTitle: 'Make sure you’re ready',
  rightBannerText:
    'Use our checklist tool to find out what info and documents you’ll need for the account types you’re inheriting.',
  rightBannerLinkText: 'Get started',
  rightBannerLink: '/document-checklist/inheritance',
};
